// extracted by mini-css-extract-plugin
export default {"container":"uI-z","error":"vI-z","disabled":"wI-z","submit":"xI-z","option":"yI-z","success":"zI-z","failure":"AI-z"};